export const CONTACTS = {
  address: "Viale dei Partigiani, 45 — 14049 Nizza Monferrato (AT)",
  phone1: "+39 0141 702987",
  phone2: "+39 349 7726359",
  email: "info@studioprojectworks.com",
  vat: "P.IVA 01591390057",
};

export const SERVICES = [
  {
    icon: "DraftingCompass",
    title: "Progettazione",
    desc: "Progetti su misura, funzionali ed efficienti, in ogni fase e scala.",
  },
  {
    icon: "Crosshair",
    title: "Rilievi",
    desc: "Rilievi topografici e laser scanner ad alta precisione per ogni esigenza.",
  },
  {
    icon: "HardHat",
    title: "Direzione Lavori",
    desc: "Gestione e controllo del cantiere per garantire qualità, tempi e costi.",
  },
  {
    icon: "Box",
    title: "Consulenza Tecnica",
    desc: "Supporto tecnico e normativo per privati, aziende e pubbliche amministrazioni.",
  },
];

export const CONSULENZE = [
  "Consulenza tecnico-immobiliare e urbanistica",
  "Studio di lottizzazioni residenziali, produttive e commerciali",
  "Conformità urbanistiche e catastali, sanatorie edilizie",
  "Pratiche edilizie e catastali",
  "Rilievi geometrici e topografici",
  "Certificazioni energetiche",
  "Perizie ordinarie, giurate e asseverate",
  "Consulenza tecnica D.Lgs. 81/08",
  "Successioni, divisioni e frazionamenti",
  "Tabelle millesimali",
  "Consulenze tecniche di parte",
  "Digital Home Staging e marketing immobiliare",
];

export const PROJECT_CATEGORIES = ["Tutti", "Residenziale", "Commerciale", "Pubblico", "Ristrutturazioni"];

export const PROJECTS = [
  {
    name: "Relax in Cascina",
    cat: "Ristrutturazioni",
    type: "Ristrutturazione di cascinale",
    meta: "400 mq · 2015—2016",
    image: "/assets/projects/relax-in-cascina.webp",
    typeEn: "Farmhouse renovation",
  },
  {
    name: "La Casa sulla Collina",
    cat: "Residenziale",
    type: "Demolizione e ricostruzione di rustico",
    meta: "330 mq + piscina · 2015—2016",
    image: "/assets/projects/casa-sulla-collina.webp",
    typeEn: "Demolition and reconstruction of a country house",
  },
  {
    name: "Villa Luppolo",
    cat: "Residenziale",
    type: "Ricostruzione di rustico",
    meta: "300 mq + piscina · 2013—2015",
    image: "/assets/projects/villa-luppolo.webp",
    typeEn: "Reconstruction of a country house",
  },
  {
    name: "Un affaccio tra le Alpi e gli Appennini Liguri",
    cat: "Residenziale",
    type: "Demolizione e ricostruzione di rustico",
    meta: "2014—2015",
    image: "/assets/projects/affaccio-alpi.webp",
    typeEn: "Demolition and reconstruction of a country house",
  },
  {
    name: "Vivere in un sito UNESCO",
    cat: "Ristrutturazioni",
    type: "Ristrutturazione di cascinale",
    meta: "600 mq · 2013—2014",
    image: "/assets/projects/sito-unesco.webp",
    typeEn: "Farmhouse renovation",
  },
  {
    name: "Vivere in centro storico",
    cat: "Ristrutturazioni",
    type: "Piano di recupero immobiliare",
    meta: "700 mq · 2011—2013",
    image: "/assets/projects/centro-storico.webp",
    typeEn: "Building recovery plan",
  },
  {
    name: "La dimensione perfetta per vivere in vacanza",
    cat: "Ristrutturazioni",
    type: "Ristrutturazione di rustico",
    meta: "130 mq · 2015—2016",
    image: "/assets/projects/vivere-in-vacanza.webp",
    typeEn: "Country house renovation",
  },
  {
    name: "Dai fiordi alla vista delle Alpi",
    cat: "Residenziale",
    type: "Ricostruzione di rustico",
    meta: "350 mq + piscina · 2013—2015",
    image: "/assets/projects/fiordi-alpi.webp",
    typeEn: "Reconstruction of a country house",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1745761321363-da0d5b6013ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBoaWxsc2lkZSUyMHZpbGxhJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg2OTcwNzM0fDA&ixlib=rb-4.1.0&q=85";

export const TEAM = [
  {
    name: "Francesco Soggiu",
    role: "Socio — Studio Tecnico Associato",
    image:
      "https://images.unsplash.com/photo-1676989880361-091e12efc056?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBtYWxlJTIwYXJjaGl0ZWN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg2OTcwNzM0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Stefano Merlino",
    role: "Socio — Studio Tecnico Associato",
    image:
      "https://images.unsplash.com/photo-1718209881007-c0ecdfc00f9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBtYWxlJTIwYXJjaGl0ZWN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg2OTcwNzM0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const ABOUT_TEXT =
  "Project Works nasce dalla collaborazione di professionisti con competenze complementari e una visione condivisa: offrire soluzioni tecniche di qualità, affidabili e innovative. Dopo singole esperienze, due soci condividono oggi idee, progetti e metodi in un unico gruppo di lavoro.";

export const ABOUT_TEXT_2 =
  "Formare ed elaborare sono azioni fondamentali per la nascita di un progetto e di un’opera architettonica che accompagnerà le generazioni future. Per questo mettiamo al primo posto la qualità dell’architettura, senza trascurare alcun aspetto del complesso processo di progettazione e realizzazione, evolvendo continuamente le nostre professionalità.";

export const ABOUT_QUOTE =
  "La nostra consulenza è un reale valore aggiunto: il confronto con un interlocutore unico assicura, in ogni fase dell’intervento, la soluzione più adatta ed efficace.";

export const GALLERY = [
  { src: "/assets/gallery/01.webp", ar: 0.6667 },
  { src: "/assets/gallery/02.webp", ar: 0.6667 },
  { src: "/assets/gallery/03.webp", ar: 0.6667 },
  { src: "/assets/gallery/04.webp", ar: 0.6667 },
  { src: "/assets/gallery/05.webp", ar: 0.6667 },
  { src: "/assets/gallery/06.webp", ar: 0.6667 },
  { src: "/assets/gallery/07.webp", ar: 0.6667 },
  { src: "/assets/gallery/08.webp", ar: 0.6667 },
  { src: "/assets/gallery/09.webp", ar: 0.6667 },
  { src: "/assets/gallery/10.webp", ar: 0.6667 },
  { src: "/assets/gallery/11.webp", ar: 0.6667 },
  { src: "/assets/gallery/12.webp", ar: 0.6667 },
  { src: "/assets/gallery/13.webp", ar: 0.6667 },
  { src: "/assets/gallery/14.webp", ar: 0.6667 },
  { src: "/assets/gallery/15.webp", ar: 0.6667 },
  { src: "/assets/gallery/16.webp", ar: 0.6667 },
  { src: "/assets/gallery/17.webp", ar: 0.6667 },
  { src: "/assets/gallery/18.webp", ar: 0.6667 },
  { src: "/assets/gallery/19.webp", ar: 0.6667 },
  { src: "/assets/gallery/20.webp", ar: 0.6667 },
  { src: "/assets/gallery/21.webp", ar: 0.6667 },
  { src: "/assets/gallery/22.webp", ar: 0.6667 },
  { src: "/assets/gallery/23.webp", ar: 0.6667 },
  { src: "/assets/gallery/24.webp", ar: 0.6667 },
  { src: "/assets/gallery/25.webp", ar: 0.6667 },
  { src: "/assets/gallery/26.webp", ar: 0.6667 },
  { src: "/assets/gallery/27.webp", ar: 0.6667 },
  { src: "/assets/gallery/28.webp", ar: 0.6667 },
  { src: "/assets/gallery/29.webp", ar: 0.6667 },
  { src: "/assets/gallery/30.webp", ar: 0.6667 },
  { src: "/assets/gallery/31.webp", ar: 0.6667 },
  { src: "/assets/gallery/32.webp", ar: 0.6667 },
  { src: "/assets/gallery/33.webp", ar: 0.6667 },
  { src: "/assets/gallery/34.webp", ar: 0.6667 },
  { src: "/assets/gallery/35.webp", ar: 0.6667 },
  { src: "/assets/gallery/36.webp", ar: 0.6667 },
  { src: "/assets/gallery/37.webp", ar: 0.6667 },
  { src: "/assets/gallery/38.webp", ar: 0.6658 },
  { src: "/assets/gallery/39.webp", ar: 0.6667 },
  { src: "/assets/gallery/40.webp", ar: 0.6667 },
  { src: "/assets/gallery/41.webp", ar: 0.6667 },
  { src: "/assets/gallery/42.webp", ar: 0.6667 },
  { src: "/assets/gallery/43.webp", ar: 0.6667 },
  { src: "/assets/gallery/44.webp", ar: 0.6667 },
  { src: "/assets/gallery/45.webp", ar: 0.6667 },
  { src: "/assets/gallery/46.webp", ar: 0.6667 },
  { src: "/assets/gallery/47.webp", ar: 0.6667 },
  { src: "/assets/gallery/48.webp", ar: 0.6667 },
  { src: "/assets/gallery/49.webp", ar: 0.6667 },
  { src: "/assets/gallery/50.webp", ar: 0.6667 },
  { src: "/assets/gallery/51.webp", ar: 0.6667 },
  { src: "/assets/gallery/52.webp", ar: 0.6667 },
  { src: "/assets/gallery/53.webp", ar: 0.6658 },
  { src: "/assets/gallery/54.webp", ar: 0.6667 },
  { src: "/assets/gallery/55.webp", ar: 0.6667 },
  { src: "/assets/gallery/56.webp", ar: 0.6667 },
  { src: "/assets/gallery/57.webp", ar: 0.6667 },
  { src: "/assets/gallery/58.webp", ar: 0.6667 },
  { src: "/assets/gallery/59.webp", ar: 0.6667 },
  { src: "/assets/gallery/60.webp", ar: 0.6667 },
  { src: "/assets/gallery/61.webp", ar: 0.6667 },
  { src: "/assets/gallery/62.webp", ar: 0.6667 },
  { src: "/assets/gallery/63.webp", ar: 0.6667 },
  { src: "/assets/gallery/64.webp", ar: 1.5 },
  { src: "/assets/gallery/65.webp", ar: 0.6658 },
  { src: "/assets/gallery/66.webp", ar: 0.6667 },
  { src: "/assets/gallery/67.webp", ar: 0.6667 },
  { src: "/assets/gallery/68.webp", ar: 0.6667 },
  { src: "/assets/gallery/69.webp", ar: 0.6667 },
  { src: "/assets/gallery/70.webp", ar: 0.6667 },
  { src: "/assets/gallery/71.webp", ar: 0.6667 },
  { src: "/assets/gallery/72.webp", ar: 0.6667 },
  { src: "/assets/gallery/73.webp", ar: 0.6667 },
  { src: "/assets/gallery/74.webp", ar: 0.6667 },
  { src: "/assets/gallery/75.webp", ar: 0.6667 },
  { src: "/assets/gallery/76.webp", ar: 0.6667 },
  { src: "/assets/gallery/77.webp", ar: 0.6667 },
  { src: "/assets/gallery/78.webp", ar: 0.6667 },
  { src: "/assets/gallery/79.webp", ar: 0.6658 },
  { src: "/assets/gallery/80.webp", ar: 0.6667 },
  { src: "/assets/gallery/81.webp", ar: 0.6667 },
  { src: "/assets/gallery/82.webp", ar: 0.6667 },
  { src: "/assets/gallery/83.webp", ar: 0.6667 },
  { src: "/assets/gallery/84.webp", ar: 0.6658 },
  { src: "/assets/gallery/85.webp", ar: 0.6667 },
  { src: "/assets/gallery/86.webp", ar: 0.6667 },
  { src: "/assets/gallery/87.webp", ar: 0.6667 },
  { src: "/assets/gallery/88.webp", ar: 0.6667 },
  { src: "/assets/gallery/89.webp", ar: 0.6667 },
  { src: "/assets/gallery/90.webp", ar: 0.6667 },
  { src: "/assets/gallery/91.webp", ar: 0.6667 },
  { src: "/assets/gallery/92.webp", ar: 0.6667 },
  { src: "/assets/gallery/93.webp", ar: 0.6667 },
  { src: "/assets/gallery/94.webp", ar: 0.6667 },
  { src: "/assets/gallery/95.webp", ar: 0.6667 },
  { src: "/assets/gallery/96.webp", ar: 0.6667 },
  { src: "/assets/gallery/97.webp", ar: 0.6667 },
  { src: "/assets/gallery/98.webp", ar: 0.6667 },
  { src: "/assets/gallery/99.webp", ar: 0.6667 },
  { src: "/assets/gallery/100.webp", ar: 0.6667 },
  { src: "/assets/gallery/101.webp", ar: 0.6667 },
  { src: "/assets/gallery/102.webp", ar: 0.6667 },
  { src: "/assets/gallery/103.webp", ar: 0.6667 },
  { src: "/assets/gallery/104.webp", ar: 0.6667 },
  { src: "/assets/gallery/105.webp", ar: 0.6667 },
  { src: "/assets/gallery/106.webp", ar: 0.6667 },
  { src: "/assets/gallery/107.webp", ar: 0.6667 },
  { src: "/assets/gallery/108.webp", ar: 0.6667 },
  { src: "/assets/gallery/109.webp", ar: 1.5 },
  { src: "/assets/gallery/110.webp", ar: 0.6667 },
  { src: "/assets/gallery/111.webp", ar: 1.0 },
  { src: "/assets/gallery/112.webp", ar: 0.5383 },
  { src: "/assets/gallery/113.webp", ar: 0.6367 },
  { src: "/assets/gallery/114.webp", ar: 1.5 },
  { src: "/assets/gallery/115.webp", ar: 0.6667 },
  { src: "/assets/gallery/116.webp", ar: 0.6675 },
  { src: "/assets/gallery/117.webp", ar: 0.475 },
  { src: "/assets/gallery/118.webp", ar: 1.4983 },
  { src: "/assets/gallery/119.webp", ar: 1.4983 },
  { src: "/assets/gallery/120.webp", ar: 1.0 },
  { src: "/assets/gallery/121.webp", ar: 0.6667 },
  { src: "/assets/gallery/122.webp", ar: 1.5 },
  { src: "/assets/gallery/123.webp", ar: 0.6775 },
  { src: "/assets/gallery/124.webp", ar: 0.715 },
  { src: "/assets/gallery/125.webp", ar: 1.4983 },
  { src: "/assets/gallery/126.webp", ar: 0.6667 },
  { src: "/assets/gallery/127.webp", ar: 0.6667 },
  { src: "/assets/gallery/128.webp", ar: 0.7075 },
  { src: "/assets/gallery/129.webp", ar: 0.7392 },
  { src: "/assets/gallery/130.webp", ar: 0.6675 },
  { src: "/assets/gallery/131.webp", ar: 0.7942 },
  { src: "/assets/gallery/132.webp", ar: 0.4292 },
  { src: "/assets/gallery/133.webp", ar: 0.6675 },
  { src: "/assets/gallery/134.webp", ar: 0.6675 },
  { src: "/assets/gallery/135.webp", ar: 0.4292 },
  { src: "/assets/gallery/136.webp", ar: 1.4983 },
  { src: "/assets/gallery/137.webp", ar: 0.6667 },
  { src: "/assets/gallery/138.webp", ar: 0.6667 },
  { src: "/assets/gallery/139.webp", ar: 1.4983 },
  { src: "/assets/gallery/140.webp", ar: 0.7625 },
  { src: "/assets/gallery/141.webp", ar: 1.5342 },
  { src: "/assets/gallery/142.webp", ar: 0.68 },
  { src: "/assets/gallery/143.webp", ar: 0.6675 },
  { src: "/assets/gallery/144.webp", ar: 0.68 },
  { src: "/assets/gallery/145.webp", ar: 1.5 },
  { src: "/assets/gallery/146.webp", ar: 0.6667 },
  { src: "/assets/gallery/147.webp", ar: 0.6675 },
  { src: "/assets/gallery/148.webp", ar: 0.6675 },
  { src: "/assets/gallery/149.webp", ar: 0.6667 },
  { src: "/assets/gallery/150.webp", ar: 0.9042 },
  { src: "/assets/gallery/151.webp", ar: 0.6667 },
  { src: "/assets/gallery/152.webp", ar: 0.8542 },
  { src: "/assets/gallery/153.webp", ar: 0.7108 },
  { src: "/assets/gallery/154.webp", ar: 1.0417 },
  { src: "/assets/gallery/155.webp", ar: 0.6675 },
  { src: "/assets/gallery/156.webp", ar: 0.7358 },
  { src: "/assets/gallery/157.webp", ar: 2.365 },
  { src: "/assets/gallery/158.webp", ar: 0.6675 },
  { src: "/assets/gallery/159.webp", ar: 0.6667 },
  { src: "/assets/gallery/160.webp", ar: 1.5 },
  { src: "/assets/gallery/161.webp", ar: 1.5 },
  { src: "/assets/gallery/162.webp", ar: 0.6667 },
  { src: "/assets/gallery/163.webp", ar: 0.6675 },
  { src: "/assets/gallery/164.webp", ar: 0.6675 },
  { src: "/assets/gallery/165.webp", ar: 0.7175 },
  { src: "/assets/gallery/166.webp", ar: 0.6667 },
  { src: "/assets/gallery/167.webp", ar: 1.5 },
  { src: "/assets/gallery/168.webp", ar: 0.6208 },
  { src: "/assets/gallery/169.webp", ar: 0.6667 },
  { src: "/assets/gallery/170.webp", ar: 1.5 },
  { src: "/assets/gallery/171.webp", ar: 0.6667 },
  { src: "/assets/gallery/172.webp", ar: 1.4983 },
  { src: "/assets/gallery/173.webp", ar: 1.5083 },
  { src: "/assets/gallery/174.webp", ar: 0.6842 },
  { src: "/assets/gallery/175.webp", ar: 0.6667 },
  { src: "/assets/gallery/176.webp", ar: 0.8008 },
  { src: "/assets/gallery/177.webp", ar: 1.285 },
  { src: "/assets/gallery/178.webp", ar: 0.6675 },
  { src: "/assets/gallery/179.webp", ar: 0.6667 },
  { src: "/assets/gallery/180.webp", ar: 0.6667 },
  { src: "/assets/gallery/181.webp", ar: 0.4375 },
  { src: "/assets/gallery/182.webp", ar: 0.6667 },
  { src: "/assets/gallery/183.webp", ar: 1.0 },
  { src: "/assets/gallery/184.webp", ar: 0.6667 },
  { src: "/assets/gallery/185.webp", ar: 1.0 },
  { src: "/assets/gallery/186.webp", ar: 0.6667 },
  { src: "/assets/gallery/187.webp", ar: 0.6083 },
];
